import React from 'react';

import { SS_CONTROL_TYPE } from '../../constants/form-manager.constants';

export const childrenToIgnore = [];

export const renderElement = (childrenTypes, isHiddenLabel, children) => (child, i) => {
  if (children.length === i - 1) {
    childrenToIgnore.length = 0;
  }

  if (childrenToIgnore.includes(i)) {
    return null;
  }

  if (
    childrenTypes[i] === SS_CONTROL_TYPE.TEXT_BOX &&
    childrenTypes[i + 1] === SS_CONTROL_TYPE.ZOOM
  ) {
    childrenToIgnore.push(i + 1);
    return (
      <div ui-ta="SSSegmentFieldSet">
        {React.cloneElement(child, {
          inFieldGroup: true,
          isHiddenLabel,
        })}
        {React.cloneElement(children[i + 1], {
          inFieldGroup: true,
          isHiddenLabel,
        })}
      </div>
    );
  }

  return React.cloneElement(child, {
    inFieldGroup: true,
    isHiddenLabel,
  });
};
